var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsLocationFillBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2D2D2D;}\n\t.st1{fill:#DB536A;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#7D7D7D;}\n\t.st4{fill:#D04A02;}\n\t.st5{fill:#464646;}\n\t.st6{fill:#E0301E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.2,22.3l-0.1-0.1c-5.8-5.8-13.4-8.7-21.1-8.7c-7.6,0-15.3,2.9-21.1,8.7l-0.1,0.1c-11.5,11.6-11.5,30.5,0.1,42.1L52,85.5 l21.1-21.1C84.7,52.8,84.7,33.9,73.2,22.3z M52,53.1c-5.8,0-10.5-4.7-10.5-10.5c0-5.8,4.7-10.5,10.5-10.5c5.8,0,10.5,4.7,10.5,10.5 C62.5,48.4,57.8,53.1,52,53.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsLocationFillBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Location_Fill_Black_RGB.3c264bae7b3bd5f61ce7f62b65bf69b7.svg";
export { ForwardRef as ReactComponent };